export default "__VITE_ASSET__DkufPJgk__"